import { AxiosInstance } from "axios";
import { Session } from "../time/time.types";

export const createNewSession = async (
  axios: AxiosInstance,
  session: Session
): Promise<Session | undefined> => {
  return axios
    .post("session/", session)
    .then((res) => res.data)
    .catch((exc) => {
      console.error("Error while saving track", exc);
      return undefined;
    });
};
export const getAllSessions = async (
  axios: AxiosInstance
): Promise<Session[]> => {
  return axios
    .get("session/all")
    .then((res) => res.data)
    .catch((exc) => {
      console.error("Error while saving track", exc);
      return [];
    });
};
export const getAllSessionsForTrack = async (
  axios: AxiosInstance,
  trackId: string
): Promise<Session[]> => {
  return axios
    .get("session/all/track", {
      params: { trackId },
    })
    .then((res) => res.data)
    .catch((exc) => {
      console.error("Error while saving track", exc);
      return [];
    });
};
export const getAllSessionsForUser = async (
  axios: AxiosInstance,
  userId: string
): Promise<Session[]> => {
  return axios
    .get("session/all/user", {
      params: { userId },
    })
    .then((res) => res.data)
    .catch((exc) => {
      console.error("Error while loading sessions", exc);
      return [];
    });
};
export const getAllSessionsForTrackAndUser = async (
  axios: AxiosInstance,
  trackId: string,
  userId: string
): Promise<Session[]> => {
  return axios
    .get("session/all/track/user", {
      params: { trackId, userId },
    })
    .then((res) => res.data)
    .catch((exc) => {
      console.error("Error while saving track", exc);
      return [];
    });
};
